module.exports = __webpack_public_path__ + "img/database.807c79bf.svg";